"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('set-off', true, function (props) {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M29 14C31.7614 14 34 11.7614 34 9C34 6.23858 31.7614 4 29 4C26.2386 4 24 6.23858 24 9C24 11.7614 26.2386 14 29 14Z",
    fill: props.colors[1],
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeMiterlimit: "2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 19L19.71 27L27.31 33.02C27.62 33.26 27.84 33.59 27.97 33.96L31.31 44",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeMiterlimit: "2",
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.71 27L14.51 34.64C12.9732 36.8883 10.5 39.5 9.5 41",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeMiterlimit: "2",
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M42 24L35.06 24.1C34.7 24.1 34.34 24.01 34.02 23.83L30.75 21.92C26.74 19.57 22.35 17.96 17.78 17.14L14.56 16.57L12 21",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeMiterlimit: "2",
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "8.65234",
    y: "19.1029",
    width: "7.35873",
    height: "9",
    transform: "rotate(30 8.65234 19.1029)",
    fill: props.colors[1],
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;